export const ip = 'https://5d.gateway.aimirainnovation.com';
// export const ip = 'http://192.168.24.151:48080';
// export const ip = 'http://192.168.12.15';

export const tenant_id = '11341';

/** 打板看板 API（生产免登录，开发走 devServer 代理） */
export const proofingBoardApi = 'https://pmosapi.aimirainnovation.com';
